import React, { useEffect } from "react";
import Logo from "../static/Logo";
import Footer from "../static/Footer";
import { useAuthStore } from "../../store/authStore";
import Header from "../static/Header";
interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { screen, resetScreen, darkMode, setDarkMode } = useAuthStore();

  useEffect(() => {
    setDarkMode(darkMode);
  }, [darkMode, setDarkMode]);

  return (
    <div
      id="AppContainer"
      className="
    /* ---------- mobile ---------- */
    flex flex-col relative
    w-[100svw]               
    h-[100dvh]              
    min-w-0 min-h-0         
    text-text-primary dark:text-text-primary-dark

    /* ---------- tablet / desktop ---------- */
    md:min-h-[550px] md:max-h-[650px]
    md:min-w-[350px] md:max-w-[400px]
    md:h-screen md:w-full
  "
    >
      <Header />
      <div className="px-8 pt-4 flex-1 flex flex-col overflow-y-auto">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
